import { Divider } from "@mui/material"
import { SearchBoxUsingSearchParam } from "lib/@components/searchBoxUsingSearchParam"
import Iconify from "minimals-template/components/Iconify"

export function LibrarySearch() {
    return (
        <>
            <SearchBoxUsingSearchParam
                placeholder="Search components..."
                sx={{ py: 0, width: 1 }}
                startAdornment={<Iconify icon="eva:search-fill" sx={{ color: "text.disabled" }} />}
            />
            <Divider sx={{ mb: 3 }} />
        </>
    )
}
